import { render, staticRenderFns } from "./AttributeButton.vue?vue&type=template&id=65657f11&"
import script from "./AttributeButton.vue?vue&type=script&lang=js&"
export * from "./AttributeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports